import { SubsolutionFilter } from "@animech/supermodel";
import { AttacherSolverContext } from "./attacher-solver-context";

type CustomSubsolutionFilter = (
	...args: [
		...Parameters<SubsolutionFilter>,
		context: Readonly<AttacherSolverContext>,
	]
) => ReturnType<SubsolutionFilter>;

const check = {
	entitiesAreWithinSnapRange: (s, context): boolean =>
		context.snapRange !== null
			? s.entityTransforms.reduce((result, entityTransform) => {
					return Math.max(result, entityTransform.deltaPosition.length());
				}, 0) <= context.snapRange
			: true,
	groupsAreValid: (s, context): boolean =>
		context.attacherGroups.every((group) => group.validateSubsolution(s)),
} as const satisfies Record<string, CustomSubsolutionFilter>;

export function createSubsolutionFilter(
	context: AttacherSolverContext,
): SubsolutionFilter {
	return (s) => check.entitiesAreWithinSnapRange(s, context);
}
